var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { ExpanderArrow } from "../Expander";
import { Label2 } from "../Labels";
export var StyledExpanderIcon = styled(ExpanderArrow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n  width: 14px;\n  height: 14px;\n"], ["\n  fill: ", ";\n  width: 14px;\n  height: 14px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.blue;
});
export var HeaderLabel = styled(Label2)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  color: ", ";\n"], ["\n  font-size: 14px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.blue;
});
var templateObject_1, templateObject_2;
